import React from 'react'
import { Typography } from 'antd'

const DataPageStub: React.FC = () => (
  <div style={{ padding: 40, textAlign: 'center' }}>
    <Typography.Title level={4}>
      Раздел находится в разработке
    </Typography.Title>
  </div>
)

export default DataPageStub
